import { render, staticRenderFns } from "./CustomerWiseProductReport.vue?vue&type=template&id=ba04dada&scoped=true&"
import script from "./CustomerWiseProductReport.vue?vue&type=script&lang=js&"
export * from "./CustomerWiseProductReport.vue?vue&type=script&lang=js&"
import style0 from "./CustomerWiseProductReport.vue?vue&type=style&index=0&id=ba04dada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba04dada",
  null
  
)

export default component.exports